import { Controller } from '@hotwired/stimulus';

// #1841: 「給与を試す」待ちページのポーリング。status エンドポイントを一定間隔で叩き、
// completed で会社トップへ自動遷移、failed で失敗カードへ切り替える。csv_status_controller.js 同型。
const POLL_INTERVAL_MS = 5000;

// 経過時間に応じてサブテキストを差し替える（時間ベースの段階メッセージ）。
const STAGE_MESSAGES = [
  { at: 0, text: '30秒ほどで自動的に切り替わります。このままお待ちください。' },
  { at: 20000, text: 'もう少しで完成です。準備ができ次第、自動で画面が切り替わります。' },
  { at: 45000, text: 'あと少しで完了します。画面はそのままでお待ちください。' },
  { at: 60000, text: 'もう少しお時間をいただいています。引き続き準備しています。' },
];

export default class extends Controller {
  static values = {
    url: String,
    redirectUrl: String,
  };

  static targets = ['stage', 'progress', 'failed'];

  connect() {
    this.startedAt = Date.now();
    this.startPolling();
    this.startStageTimer();
  }

  disconnect() {
    this.stopPolling();
    this.stopStageTimer();
  }

  startPolling() {
    this.stopPolling();
    this.timer = setInterval(() => this.poll(), POLL_INTERVAL_MS);
  }

  stopPolling() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  startStageTimer() {
    this.updateStage();
    this.stageTimer = setInterval(() => this.updateStage(), 5000);
  }

  stopStageTimer() {
    if (this.stageTimer) {
      clearInterval(this.stageTimer);
      this.stageTimer = null;
    }
  }

  updateStage() {
    if (!this.hasStageTarget) return;
    const elapsed = Date.now() - this.startedAt;
    const stage = STAGE_MESSAGES.filter((s) => elapsed >= s.at).pop();
    if (stage) this.stageTarget.textContent = stage.text;
  }

  async poll() {
    try {
      const res = await fetch(this.urlValue, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      if (data.status === 'failed') {
        this.showFailure();
      } else if (data.finished) {
        this.stopPolling();
        this.stopStageTimer();
        window.location.href = data.redirect_url || this.redirectUrlValue;
      }
    } catch (_e) {
      // network blip — retry on next tick
    }
  }

  showFailure() {
    this.stopPolling();
    this.stopStageTimer();
    if (this.hasProgressTarget) this.progressTarget.hidden = true;
    if (this.hasFailedTarget) this.failedTarget.hidden = false;
  }
}
